import React from 'react';
import classNames from 'classnames/bind';
import styles from './FormCanNot.module.scss';
import { Row, Form } from 'antd';
import { SVGS } from '~/assets/assetsPath';

const cx = classNames.bind(styles);

const FormCanNot = ({ onAgree, text, ...props }) => {
    return (
        <Form>
            <Form.Item>
                <Row justify="center" className={cx('name_page')}>
                    {props?.title || `Notice`}
                </Row>
            </Form.Item>
            <Form.Item>
                <Row justify="center" className={cx('bio')} style={{ textAlign: props?.textAlignStart ? 'start' : '' }}>
                    {text}
                </Row>
            </Form.Item>
            {props?.btnBottom ? (
                <Form.Item style={{ marginTop: '40px' }}>
                    <Row justify="center">
                        <div className={cx('btn_logout')} onClick={onAgree}>
                            Close
                        </div>
                    </Row>
                </Form.Item>
            ) : (
                ''
            )}
        </Form>
    );
};

export default FormCanNot;
